/* eslint-disable */
import React from 'react';
import wrapDisplayName from 'recompose/wrapDisplayName';
import envIsProduction from '../../Support/Env/IsProduction/EnvIsProduction.support';
import EntriesContext from './Entries.context';

/**
 * Provide a way for components to know which entry bootstrapped them. This wrapper adds `this.props.entry` with the given entry name
 * @export
 * @param {React.Component} Component The Component to wrap
 * @returns {React.Component} The rendered `<Component />`
 */
const withEntries = (Component) => {
  /**
   * Render the component
   * @param {any} props The props that were passed in to `<Component />`
   * @returns {React.Component} The rendered `<WrappedComponent />`
   */
  const WrappedComponent = (props) => (
    <EntriesContext.Consumer>{(entryOrFallback) => <Component {...props} entry={entryOrFallback} />}</EntriesContext.Consumer>
  );
  // Update the `displayName` of the `<Component />` so that in any warnings or Error's that may be thrown, we know that the component is wrapped
  if (!envIsProduction()) {
    WrappedComponent.displayName = wrapDisplayName(Component, `WithEntries`);
  }
  return WrappedComponent;
};

export default withEntries;
